import { useQuery } from 'react-query';
import { createFetchAPI } from '../http';

const fetchMerchantConnectStampCard = createFetchAPI<
  FetchStampCardRequest,
  FetchStampCardResponse
>();

export const useFetchMerchantConnectStampCard = (
  { loyalty_settings_id }: FetchStampCardRequest,
  enabled: boolean,
) =>
  useQuery<FetchStampCardResponse>(
    [
      'fetchMerchantConnectStampCard',
      { url: `v1/mc_products/${loyalty_settings_id}` },
    ],
    fetchMerchantConnectStampCard,
    { enabled },
  );

type FetchStampCardRequest = {
  loyalty_settings_id: string;
};

type CurrencyAmount = {
  currency: string;
  amount: number;
};

type RewardableDetails = {
  name: string;
  description: string;
  redemption_start_date: string;
  redemption_end_date: string;
  validity_days: number;
  image_ids: number[];
  image_urls: string[];
  what_you_get: string;
  fine_print: string;
  redemption_instructions: string;
};

type LoyaltyRewardableSetting = {
  required_stamps_count: number;
  rewardable_type: string;
  rewardable_details: RewardableDetails;
};

type ProductDetails = {
  min_spending_amount: CurrencyAmount;
  min_spending_amount_humanize: string;
  total_stamps_count: string;
  duration: number;
  start_date: string;
  end_date: string;
  description: string;
  fine_print: string;
  loyalty_rewardable_settings: LoyaltyRewardableSetting[];
};

type Company = {
  id: string;
  name: string;
  merchant_type: string;
};

export type FetchStampCardResponse = {
  id: string;
  company: Company;
  product_type: string;
  product_details: ProductDetails;
};
